import { urlRefreshTokentV2 } from "@/api/endpoint";
import customer from "@/storage/customer";
import orders from "@/storage/orders";
import address from "@/storage/address";
import { fetchPostAuthorizationCSRFV2 } from "../fetch/fetchPostAuthorizationCSRFV2";

export interface FetchMeResponse {
    jwt?: string;
    [key: string]: any;
}

export async function fetchMe(data: any): Promise<FetchMeResponse> {
    const res: FetchMeResponse = await fetchPostAuthorizationCSRFV2(urlRefreshTokentV2, data);

    if (res && res.class === 'success') {
        customer.setCustomerData(res.customer);
        orders.setOrderData(res.customer.orders);
        address.setAddressData(res.customer.addresses);
    }

    return res;
}